import React, { useState } from 'react';
import { Plus, X, RefreshCw } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';

const TagsSection = ({ predefinedTags, setPredefinedTags, onSaveTags }) => {
  const [newTagName, setNewTagName] = useState('');
  const [newTagColor, setNewTagColor] = useState(COLORS.primary);
  const [newTagDescription, setNewTagDescription] = useState('');
  const [editingTag, setEditingTag] = useState(null);

  const addTag = () => {
    if (newTagName.trim() && !predefinedTags.find(t => t.name === newTagName.trim())) {
      setPredefinedTags([...predefinedTags, { 
        name: newTagName.trim(), 
        color: newTagColor,
        description: newTagDescription.trim()
      }]);
      setNewTagName('');
      setNewTagDescription('');
    }
  };

  const removeTag = (tagName) => {
    setPredefinedTags(predefinedTags.filter(t => t.name !== tagName));
  };

  const updateTag = () => {
    if (!editingTag) return;
    setPredefinedTags(predefinedTags.map(t => 
      t.name === editingTag.originalName 
        ? { name: editingTag.name, color: editingTag.color, description: editingTag.description }
        : t
    ));
    setEditingTag(null);
  };

  return (
    <div style={{
      backgroundColor: COLORS.card,
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${COLORS.border}`,
      marginBottom: '16px',
    }}>
      <h3 style={{ color: COLORS.text, fontSize: '16px', fontWeight: '600', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '20px' }}>🏷️</span>
        Предлагаемые теги
      </h3>
      
      {/* Existing Tags */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
        {predefinedTags.map((tag) => (
          <div key={tag.name} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '10px 14px',
            backgroundColor: COLORS.background,
            borderRadius: '8px',
            border: `1px solid ${COLORS.border}`,
          }}>
            {editingTag?.originalName === tag.name ? (
              <>
                <input
                  type="color"
                  value={editingTag.color}
                  onChange={(e) => setEditingTag({ ...editingTag, color: e.target.value })}
                  style={{ width: '32px', height: '32px', padding: '0', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                />
                <input
                  type="text"
                  value={editingTag.name}
                  onChange={(e) => setEditingTag({ ...editingTag, name: e.target.value })}
                  style={{ flex: 1, padding: '6px 10px', backgroundColor: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: '6px', color: COLORS.text, fontSize: '13px' }}
                />
                <input
                  type="text"
                  value={editingTag.description}
                  onChange={(e) => setEditingTag({ ...editingTag, description: e.target.value })}
                  placeholder="Описание..."
                  style={{ flex: 2, padding: '6px 10px', backgroundColor: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: '6px', color: COLORS.text, fontSize: '13px' }}
                />
                <button
                  onClick={updateTag}
                  style={{ padding: '6px 12px', backgroundColor: COLORS.success, border: 'none', borderRadius: '6px', color: '#fff', cursor: 'pointer', fontSize: '12px' }}
                >
                  Сохранить
                </button>
                <button
                  onClick={() => setEditingTag(null)}
                  style={{ padding: '6px 12px', backgroundColor: COLORS.border, border: 'none', borderRadius: '6px', color: COLORS.text, cursor: 'pointer', fontSize: '12px' }}
                >
                  Отмена
                </button>
              </>
            ) : (
              <>
                <div style={{ width: '24px', height: '24px', borderRadius: '6px', backgroundColor: tag.color, flexShrink: 0 }} />
                <span style={{ color: COLORS.text, fontSize: '14px', fontWeight: '600', minWidth: '100px' }}>{tag.name}</span>
                <span style={{ color: COLORS.textSecondary, fontSize: '12px', flex: 1 }}>{tag.description}</span>
                <button
                  onClick={() => setEditingTag({ ...tag, originalName: tag.name })}
                  style={{ background: 'none', border: 'none', color: COLORS.primary, cursor: 'pointer', padding: '4px' }}
                >
                  <RefreshCw size={14} />
                </button>
                <button
                  onClick={() => removeTag(tag.name)}
                  style={{ background: 'none', border: 'none', color: COLORS.danger, cursor: 'pointer', padding: '4px' }}
                >
                  <X size={16} />
                </button>
              </>
            )}
          </div>
        ))}
      </div>

      {/* Add New Tag */}
      <div style={{ padding: '14px', backgroundColor: `${COLORS.primary}08`, borderRadius: '8px', border: `1px solid ${COLORS.primary}20` }}>
        <div style={{ color: COLORS.textSecondary, fontSize: '12px', marginBottom: '10px', fontWeight: '600' }}>Добавить новый тег</div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <input
            type="color"
            value={newTagColor}
            onChange={(e) => setNewTagColor(e.target.value)}
            style={{ width: '40px', height: '40px', padding: '0', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
          />
          <input
            type="text"
            value={newTagName}
            onChange={(e) => setNewTagName(e.target.value)}
            placeholder="Название тега..."
            style={{
              flex: 1,
              padding: '10px 14px',
              backgroundColor: COLORS.background,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '8px',
              color: COLORS.text,
              fontSize: '14px',
            }}
            onKeyPress={(e) => e.key === 'Enter' && addTag()}
          />
          <input
            type="text"
            value={newTagDescription}
            onChange={(e) => setNewTagDescription(e.target.value)}
            placeholder="Описание (опционально)..."
            style={{
              flex: 2,
              padding: '10px 14px',
              backgroundColor: COLORS.background,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '8px',
              color: COLORS.text,
              fontSize: '14px',
            }}
            onKeyPress={(e) => e.key === 'Enter' && addTag()}
          />
          <button
            onClick={addTag}
            style={{
              padding: '10px 16px',
              backgroundColor: COLORS.primary,
              border: 'none',
              borderRadius: '8px',
              color: '#000',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontWeight: '600',
            }}
          >
            <Plus size={18} />
            Добавить
          </button>
        </div>
      </div>
    </div>
  );
};

export default TagsSection;
